import { useClientData } from '@/providers/ClientData.provider';

// Pre-funding (Pay From, Deposit Collected Funds To, Pre-Funding Settings) doesn't apply to
// client-accounts mode or to Technology accounts.
export default function usePreFundingEnabled(): boolean {
  const {
    response: { clientAccountsEnabled, AccountType },
  } = useClientData();

  return !clientAccountsEnabled && AccountType !== 'Technology';
}
